import React from "react";
import { Table } from "antd";
import { SpinSize } from "antd/lib/spin";
import { DocumentNode } from "@apollo/client";
import { ColumnsType } from "antd/lib/table/interface";
import { Item } from "@design-system";
import { DataImport } from "./data-import";
import { FileFormat } from "./data-import-form";
import { VpdDataImportType } from "../../graphql/__generated_types__/globalTypes";

export type DataImportTableLabels = {
  importButtonLabel?: string;
  importHintText?: string;
  loadingText?: string;
  emptyText?: string;
};

export type DataImportTableProps<T> = {
  columns: ColumnsType<T>;
  loading?: boolean;
  items?: T[];
  importType: VpdDataImportType;
  fetchQuery?: DocumentNode;
  labels?: DataImportTableLabels;
  accept?: FileFormat[];
};

export const DataImportTable = <T extends Item>({
  columns,
  loading,
  items,
  importType,
  fetchQuery,
  labels: {
    importButtonLabel = "Import",
    importHintText,
    loadingText = "Loading...",
    emptyText = "No data imported yet",
  } = {},
}: DataImportTableProps<T>) => {
  const spin = { tip: loadingText, size: "large" as SpinSize };

  return (
    <DataImport
      isLibraryScope={importType.startsWith("Library")}
      labels={{ importButtonLabel, importHintText }}
      importType={importType}
      fetchQuery={fetchQuery}
      renderContent={() => (
        <Table
          columns={columns}
          dataSource={items}
          loading={loading ? spin : false}
          rowKey="id"
          pagination={{ pageSize: 10 }}
          locale={{ emptyText: emptyText }}
        />
      )}
    />
  );
};
